<template>
  <Teleport to="body">
    <div v-if="show" class="fixed inset-0 flex items-center justify-end sm:justify-center bg-slate-900/50 z-50">
      <div
        :class="modalWidth"
        class="w-full top-0 sm:top-0 bg-white rounded-lg shadow-lg relative"
      > <!-- class="w-full top-32 sm:top-4 bg-white rounded-lg shadow-lg relative" -->
        <button v-if="type === 'default'" @click="$emit('close')" 
          class="absolute top-3 right-4 p-1.5 bg-transparent hover:bg-slate-200 hover:text-slate-900 rounded-lg"
          >
          <IconClose class="w-5 h-5" />
        </button>
        
        <!-- Header Slot -->
        <div v-if="$slots.header" 
            class="mb-4 px-4 py-3 rounded-t-lg flex items-center
                  text-xl font-semibold
                  text-skin-b-list-base
                  bg-skin-b-list-head border-b border-skin-b-list-bord"
            :class="{'pr-8' : type === 'default',}"
          >
          <slot name="header"></slot>
        </div>
        
        <!-- Body Slot -->
        <div class="mx-4">
          <slot></slot>
        </div>
        
        <!-- Footer Slot -->
        <div v-if="$slots.footer && type === 'default'" 
            class="mt-4 flex justify-between space-x-2 p-4 rounded-b-lg 
                  bg-skin-b-list-head border-t border-skin-b-list-bord"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import IconClose from '../icons/IconClose.vue'

export default {
  emits: ['close'],
  components: {
        IconClose,
  },
  props: {
    show: Boolean,
    width: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    },
    type: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'info'].includes(value)
    }
  },

  computed: {
    modalWidth() {
      return {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg'
      }[this.width];
    }
  }
};
</script>

<style scoped>
</style>
